import { ValidationFailure } from "../../../errors/validation-failure";

export abstract class ValidatorBase {
    private _failures: Array<ValidationFailure>;

    addFailure(failure: ValidationFailure): void {
        if (this._failures == null) {
            this._failures = [];
        }

        this._failures.push(failure);
    }

    getFailures(): Array<ValidationFailure> {
        return this._failures ?? [];
    }
}
